import React from 'react';
import { FormattedMessage } from 'react-intl';
import messages from './messages';
import { Col, Row } from 'react-bootstrap';
import { Stack } from '@fortress-technology-solutions/fortress-component-library/Atoms';
import ElementWithPermissions from '../../../components/ElementWithPermissions';
import SubmitButton from '../../../components/SubmitButton';
import { SUBSIDY_FILTER_OPTIONS } from '../constants';
import useGetAllFiscalPeriods from '../../../hooks/useGetAllFiscalPeriods';
import useIntl from '../../../hooks/useIntl';
import { generateFiscalPeriodsOption } from './utils';

type Props = {
  organizationId: string,
  propertyId: string,
  redirectToCreatePaymentBatch: Function,
  subsidyFilter: string,
  onSubsidyFilterChange: (value: string) => void,
  periodFilter: string,
  onPeriodFilterChange: (value: string) => void,
};

const ManagePaymentBatchesHeader = (props: Props) => {
  const intl = useIntl();
  const {
    organizationId,
    propertyId,
    redirectToCreatePaymentBatch,
    subsidyFilter,
    onSubsidyFilterChange,
    periodFilter,
    onPeriodFilterChange,
  } = props;
  const [fiscalPeriods, fiscalPeriodsLoading] = useGetAllFiscalPeriods({
    propertyId,
    organizationId,
  });
  const fiscalPeriodsOption = generateFiscalPeriodsOption(
    fiscalPeriods,
    fiscalPeriodsLoading,
  );

  return (
    <div className="container-fluid">
      <Row>
        <Col xs={12} md={4}>
          <h1>
            <FormattedMessage {...messages.header} />
          </h1>
        </Col>
        <Col xs={12} md={8}>
          <Stack
            direction="row"
            spacing={1.5}
            alignItems="flex-end"
            justifyContent="flex-end"
            flexWrap="wrap"
          >
            <Stack spacing={0.5}>
              <label htmlFor="periodFilter">
                <FormattedMessage {...messages.filterByPeriod} />
              </label>
              <select
                id="periodFilter"
                className="input-md form-control"
                style={{ width: '200px' }}
                value={periodFilter}
                onChange={(e) => onPeriodFilterChange(e.target.value)}
              >
                {fiscalPeriodsOption.map((option) => (
                  <option
                    key={option.value || 'choose'}
                    value={option.value}
                    disabled={option.disabled}
                  >
                    {option.text}
                  </option>
                ))}
              </select>
            </Stack>
            <Stack spacing={0.5}>
              <label htmlFor="subsidyFilter">
                <FormattedMessage {...messages.filterBySubsidy} />
              </label>
              <select
                id="subsidyFilter"
                className="input-md form-control"
                style={{ width: '200px' }}
                value={subsidyFilter}
                onChange={(e) => onSubsidyFilterChange(e.target.value)}
              >
                {SUBSIDY_FILTER_OPTIONS.map((option) => (
                  <option key={option.value} value={option.value}>
                    {intl.formatMessage(option.text)}
                  </option>
                ))}
              </select>
            </Stack>
            <ElementWithPermissions scope={['payment-batch-manage']}>
              <SubmitButton
                type="button"
                bsStyle="warning"
                href="#"
                clickHandler={() => redirectToCreatePaymentBatch()}
                isSubmitting={false}
              >
                <FormattedMessage {...messages.createPaymentBatch} />
              </SubmitButton>
            </ElementWithPermissions>
          </Stack>
        </Col>
      </Row>
    </div>
  );
};

export default ManagePaymentBatchesHeader;
